import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { IAgent, IMachineFromApi } from 'app/models';
import { AgentService } from 'app/services';

@Component({
  selector: 'app-agent-pwd-gen-dialog',
  templateUrl: './agent-pwd-gen-dialog.component.html',
  styleUrls: ['./agent-pwd-gen-dialog.component.scss'],
})
export class AgentPwdGenDialogComponent {
  title = 'Agent password generation';
  pwdGenerated: string | undefined;
  errorMsg: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<AgentPwdGenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AgentPwdGenDialogModel,
    private agentService: AgentService
  ) {}

  onConfirm(): void {
    this.agentService.generatePwd(this.data.agent.id).subscribe(
      (res) => (this.pwdGenerated = res.password),
      () => (this.errorMsg = 'Password generation error')
    );
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class AgentPwdGenDialogModel {
  constructor(
    public agent: IAgent,
    public machine: IMachineFromApi | undefined
  ) {}
}
